import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { SEOHead } from "@/components/SEOHead";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-background font-sans text-foreground">
      <SEOHead 
        title="Page Not Found | Woods Spine & Wellness"
        description="The page you are looking for doesn't exist or has been moved."
        noIndex={true}
      />
      <Navbar />
      <main className="flex flex-grow items-center justify-center py-24">
        <div className="text-center container mx-auto px-4 max-w-md">
          <h1 className="mb-4 text-8xl font-bold text-primary">404</h1>
          <h2 className="mb-4 text-3xl font-semibold">Page Not Found</h2>
          <p className="mb-8 text-lg text-muted-foreground">
            Oops! The page you are looking for doesn&apos;t exist or has been moved.
          </p>
          <Button asChild size="lg" className="bg-accent text-white hover:bg-accent/90">
            <Link to="/">Return to Home</Link>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
